import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { responseError } from '../../../helpers/response/ResponseHelper'
import MySelectSearch from '../../UI/form/MySelectSearch'
import { getSuppliersAPI } from '../../../api/supply/supplierAPI'

const SuppliersSearchSelectMain = ({ required, setValidate, setValueForm, forciblyValue, className }) => {

    const [value, setValue] = useState(forciblyValue)
    const [query, setQuery] = useState('')
    // console.log('query', query)
  	const [validSelect, setValidSelect] = useState(false)
	const [suppliers, setSuppliers] = useState([])
	const [loading, setLoading] = useState(false)

	useEffect(() => {
        if (query && query.length >= 2) {
            getSuppliers()
        } else {
            setSuppliers([])
        }
	}, [query])

	useEffect(() => {
		valid()
	}, [required, value])

	const getSuppliers = () => {
        setLoading(true)
        setSuppliers([])
		getSuppliersAPI({ query }).then(data => {
			setSuppliers(data.suppliers)
            setLoading(false)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
            setLoading(false)
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
				setValidSelect(true)
			} else {
				setValidate(false)
				setValidSelect(false)
			}
		} else {
			setValidate(true)
			setValidSelect(true)
		}
	}

  return (
	<div className={className}>
		<MySelectSearch
			// optionDefault={}
			// nameField={}
			setQuery={setQuery}
			label={'Підрядник (постачальник)'}
			placeholder={'Введіть для пошуку'}
			labelId={'select__supplier-label'}
			id={'select__supplier'}
			// value={value ? {id: value, name: suppliers[0].name} : ''}
			value={value}
			onChange = {e => {
				setValueForm(e)
				setValue(e)
			}}
			loading={loading}
			setLoading={setLoading}
			// disabled={}
			// loading={}
			options={
				suppliers && suppliers.length > 0 ? 
					suppliers.map(supplier => {
						// return {id: supplier.id, name: getUserName({ user })}
						return {id: supplier.id, name: `${supplier.name} (${supplier.edrpou})`}
						// return {id: supplier.id, name: `${supplier.name}`}
					})
				: []	
			}
		/>
	</div>
  )
}

export default SuppliersSearchSelectMain